import { render } from "./PeriodSelectionButton.vue?vue&type=template&id=72ec8129"
import script from "./PeriodSelectionButton.vue?vue&type=script&lang=js"
export * from "./PeriodSelectionButton.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/arda/arda-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__